import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { TextJustifier } from './TextJustifier';
var EastAsianJustifier = /** @class */ (function (_super) {
    __extends(EastAsianJustifier, _super);
    function EastAsianJustifier(locale, lineJustification, justificationStyle) {
        if (locale === void 0) { locale = 'ja'; }
        if (lineJustification === void 0) { lineJustification = 'allButLast'; }
        if (justificationStyle === void 0) { justificationStyle = 'pushInKinsoku'; }
        var _this = this;
        locale = axCoerceString(locale);
        lineJustification = axCoerceString(lineJustification);
        justificationStyle = axCoerceString(justificationStyle);
        _this = _super.call(this, undefined, undefined) || this;
        console.warn('[EastAsianJustifier] not implemented');
        return _this;
    }
    Object.defineProperty(EastAsianJustifier.prototype, "justificationStyle", {
        // AS -> JS Bindings
        // _justificationStyle: string;
        // _composeTrailingIdeographicSpaces: boolean;
        get: function () {
            console.warn('[EastAsianJustifier] - get justificationStyle not implemented');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            console.warn('[EastAsianJustifier] - set justificationStyle not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EastAsianJustifier.prototype, "composeTrailingIdeographicSpaces", {
        get: function () {
            console.warn('[EastAsianJustifier] - get composeTrailingIdeographicSpaces not implemented');
            return null;
        },
        set: function (value) {
            console.warn('[EastAsianJustifier] - set composeTrailingIdeographicSpaces not implemented');
        },
        enumerable: true,
        configurable: true
    });
    EastAsianJustifier.forceNativeConstructor = true;
    EastAsianJustifier.forceNativeMethods = true;
    return EastAsianJustifier;
}(TextJustifier));
export { EastAsianJustifier };
